module.exports = __webpack_public_path__ + "img/Martin-Butters.4643e2e5.webp";